import React from "react";
import { T } from "../../hooks/useTranslate";

import { Box, Typography } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import { CopyToClipboard } from "../CopyToClipboard";

import {
  gridTextStyle,
  gridChildLeftWrapper,
} from "./drawer-styles";
import { getFormattedPrimaryPhoneNumber } from "../../utils/phoneUtils";


const ProfilePhoneLine = ({ customerHrefData, drawerType, eventLocation }) => {
  const formattedPhoneNumber = getFormattedPrimaryPhoneNumber(customerHrefData);

  return (
    <>
      <Box sx={gridChildLeftWrapper}>
        <PhoneIcon sx={{ height: 14, width: 14 }} data-test-id={`${drawerType}-profile-phone-icon`} />
      </Box>
      {formattedPhoneNumber !== "" ? (
        <Box component="span" sx={{ fontSize: "calc(12px * var(--unicity-font-scale, 1))", textDecoration: "underline" }}>
          <CopyToClipboard
            text={formattedPhoneNumber}
            stringToCopy={formattedPhoneNumber}
            iconId={`${drawerType}-profile-copy-phone`}
            data-test-id={`${drawerType}-profile-copy-phone`}
            eventLocation={eventLocation}
            eventName="phone_copy"
            sendEvent={true}
            userType={drawerType}
            userId={customerHrefData.unicity}
          />
        </Box>
      ) : (
        <Typography sx={gridTextStyle} data-test-id={`${drawerType}-profile-phone`}>
          <T>not_available</T>
        </Typography>
      )}
    </>
  )
}

export { ProfilePhoneLine }